import PropTypes from 'prop-types';
import React from 'react';

class ErrorCatcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Mettez à jour l'état, de façon à montrer l'UI de repli au prochain rendu.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { onError } = this.props;
    onError(error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    if (hasError) return null;

    const { children } = this.props;
    return children;
  }
}

ErrorCatcher.propTypes = {
  children: PropTypes.element.isRequired,
  onError: PropTypes.func.isRequired,
};

export default ErrorCatcher;
